<template>
  <div class="product-price-info">
    <div class="product-price-info__desc">
      <p>{{ $t('Pickup price') }}</p>
    </div>
    <img src="@/assets/images/icons/warehouse.svg" :alt="$t('Pickup price')" />
  </div>
</template>

<script>
export default {
  name: 'ProductPriceNotice',
}
</script>

<style lang="scss">
@import '~bootstrap/scss/functions';
@import '@/assets/scss/config';
@import '@/assets/scss/mixins';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

@keyframes showPriceDesc {
  0% {
    opacity: 0;
    transform: translateY(5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.product-price-info {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  margin-top: -2px;
  width: 16px;
  height: 16px;

  > img {
    width: 100%;
    height: 100%;
    cursor: help;
  }

  &__desc {
    position: absolute;
    bottom: calc(100% + 5px);
    left: 0;
    background-color: #f9fafb;
    color: $DGray;
    width: 200px;
    border-radius: 6px;
    font-size: 14px;
    padding: 4px 6px;
    font-weight: 400;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
    display: none;
    animation: showPriceDesc 300ms ease-out forwards;
  }

  &:hover &__desc {
    display: block;
  }
}
</style>
